/**
 * Určuje variantu stylů MenuItemComponent.
 */
export enum MenuItemComponentVariant {
    /** Základní zobrazení. */
    default = "default",
    /** Typ pro položky menu uživatele. */
    usermenu = "usermenu",
    /** Specifický typ pro tlačítko odhlásit. */
    logout = "logout",
}
